// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"1a885da3","41":"e86f3718","63":"cf058695","479":"9b5d6a3a","589":"49ddad0a","649":"4125b3af","690":"8155a521","746":"7dd2e9fb","754":"e56aa96b","940":"02561579"}[chunkId] + ".chunk.js";
};